import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';


const FilterPanel = ({ filters, onFilterChange, onClearFilters }) => {
  const statusOptions = [
    { value: 'all', label: 'Todos los Estados' },
    { value: 'En Venta', label: 'En Venta' },
    { value: 'Próximamente', label: 'Próximamente' },
    { value: 'Agotado', label: 'Agotado' }
  ];

  const priceRangeOptions = [
    { value: 'all', label: 'Todos los Precios' },
    { value: '0-100000', label: 'Hasta S/ 100,000' },
    { value: '100000-200000', label: 'S/ 100,000 - S/ 200,000' },
    { value: '200000-300000', label: 'S/ 200,000 - S/ 300,000' },
    { value: '300000+', label: 'Más de S/ 300,000' }
  ];

  const locationOptions = [
    { value: 'all', label: 'Todas las Ubicaciones' },
    { value: 'Cayma', label: 'Cayma' },
    { value: 'Cerro Colorado', label: 'Cerro Colorado' },
    { value: 'Yanahuara', label: 'Yanahuara' },
    { value: 'Sachaca', label: 'Sachaca' }
  ];

  const typeOptions = [
    { value: 'all', label: 'Todos los Tipos' },
    { value: 'Residencial', label: 'Residencial' },
    { value: 'Comercial', label: 'Comercial' },
    { value: 'Mixto', label: 'Mixto' }
  ];

  return (
    <div className="card mb-6 md:mb-8">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl md:text-2xl font-semibold text-foreground">
          Filtrar Proyectos
        </h3>
        <Button
          variant="ghost"
          size="sm"
          iconName="X"
          iconPosition="left"
          onClick={onClearFilters}
        >
          Limpiar
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <Select
          label="Estado"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Select
          label="Rango de Precio"
          options={priceRangeOptions}
          value={filters?.priceRange}
          onChange={(value) => onFilterChange('priceRange', value)}
        />

        <Select
          label="Ubicación"
          options={locationOptions}
          value={filters?.location}
          onChange={(value) => onFilterChange('location', value)}
        />

        <Select
          label="Tipo de Desarrollo"
          options={typeOptions}
          value={filters?.type}
          onChange={(value) => onFilterChange('type', value)}
        />
      </div>
      <Input
        type="search"
        placeholder="Buscar por nombre de proyecto..."
        value={filters?.search}
        onChange={(e) => onFilterChange('search', e?.target?.value)}
      />
    </div>
  );
};

export default FilterPanel;